import withFilters from "./hoc";
import projectFilters from "./projectFilters";
import makerFilters from "./makerFilters";
import eventFilters from "./eventFilters";
import resourceCollectionFilters from "./resourceCollectionFilters";
import resourceFilters from "./resourceFilters";
import userFilters from "./userFilters";
import keywordFilter from "./keywordFilter";
import journalFilters from "./journalFilters";
import entitlementFilters from "./entitlementFilters";
import assetFilters from "./assetFilters";

export default withFilters;

export {
  projectFilters,
  makerFilters,
  eventFilters,
  resourceCollectionFilters,
  resourceFilters,
  userFilters,
  keywordFilter,
  journalFilters,
  entitlementFilters,
  assetFilters
};
